'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.content-filter.cb-content-filter-category', []);

_module.directive('cbContentFilterCategory', cbContentFilterCategoryDirective);

exports.default = _module;


function cbContentFilterCategoryDirective() {
    return {
        scope: true,
        require: {
            cbContentFilter: '^^cbContentFilter',
            cbContentFilterCategory: 'cbContentFilterCategory'
        },
        bindToController: {
            cbFilterIsDefaultActive: '@cbFilterIsDefaultActive',
            cbCategoryName: '@cbContentFilterCategory'
        },
        controller: 'ContentFilterCategoryController',
        controllerAs: 'cfc'
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/content-filter/cb-content-filter-category.directive.js
// module id = 877
// module chunks = 0